import type { ActionAlertUrgency } from "@/lib/actionAlerts/dueDate";

export type ActionAlertTarget = {
  type: string;
  id: number;
  title?: string;
};

export type ActionAlert = {
  key: string;
  source: string;
  kind: string;
  urgency: ActionAlertUrgency;
  title: string;
  body: string;
  due_at: string | null;
  assigned_to_me: boolean;
  assigned_to_name: string | null;
  target: ActionAlertTarget | null;
  opportunity_id?: number;
  opportunity_title?: string;
  application_id?: number;
  application_title?: string;
  task_id?: number;
};

export type ActionAlertsSummary = {
  total: number;
  overdue: number;
  urgent: number;
  assigned_to_me: number;
  truncated?: boolean;
};

export type ActionAlertsResponse = {
  alerts: ActionAlert[];
  summary: ActionAlertsSummary;
};

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

function alertsPath(municipalityId: number): string {
  return `/api/v1/municipalities/${municipalityId}/action_alerts`;
}

export async function listActionAlerts(municipalityId: number): Promise<ActionAlertsResponse> {
  const response = await fetch(alertsPath(municipalityId), {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error("Failed to load action alerts");
  }
  return response.json();
}

export async function dismissActionAlert(municipalityId: number, alertKey: string): Promise<void> {
  const response = await fetch(`${alertsPath(municipalityId)}/dismiss`, {
    method: "POST",
    credentials: "include",
    headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
    body: JSON.stringify({ alert_key: alertKey }),
  });
  if (!response.ok) {
    throw new Error("Failed to dismiss alert");
  }
}

export async function dismissAllActionAlerts(municipalityId: number): Promise<void> {
  const response = await fetch(`${alertsPath(municipalityId)}/dismiss_all`, {
    method: "POST",
    credentials: "include",
    headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
  });
  if (!response.ok) {
    throw new Error("Failed to dismiss alerts");
  }
}
